import { lazy } from "react";

const ProfilePage = lazy(()=> import("../../views/client/ProfilePage"))
const Dashboard = lazy(()=> import("../../views/client/Dashboard"))
const MyPool = lazy(()=> import("../../views/client/MyPool"))
const NewPool = lazy(()=> import("../../views/client/NewPool"))
const ConnectToCompany = lazy(()=> import("../../views/client/ConnectToCompany"))


const Messages = lazy(()=> import("../../views/client/Messages/Messages"))
const NewCompanyChat = lazy(()=> import("../../views/client/Messages/NewCompanyChat"))
const CompanyConversation = lazy(()=> import("../../views/client/Messages/CompanyConversation"))
const ClientNotifications = lazy(() => import("../../views/client/Notifications"))

const Companies = lazy(()=> import("../../views/client/companies/Companies"))
const SavedCompanies = lazy(()=> import("../../views/client/companies/SavedCompanies"))

const CompanyProfilePage = lazy(()=> import("../../views/client/companies/CompanyProfilePage"))
const EquipmentDetailView = lazy(()=> import("../../views/client/equipment/EquipmentDetailView"))
const EquipmentList = lazy(()=> import("../../views/client/equipment/EquipmentList"))
const NewEquipment = lazy(() => import("../../views/client/equipment/NewEquipment"));
const Settings = lazy(()=> import("../../views/client/Settings"))
const CreateServiceLocation = lazy(()=> import("../../views/client/serviceLocations/CreateServiceLocation"))
const ConnectServiceLocation = lazy(()=> import("../../views/client/serviceLocations/ConnectServiceLocation"))
const ServiceHistoryDetail = lazy(()=> import("../../views/client/serviceHistory/ServiceHistoryDetail"))

const RepairRequests = lazy(() => import("../../views/client/repairRequests/RepairRequests"));
const NewRepairRequest = lazy(()=> import("../../views/client/repairRequests/NewRepairRequest"))
const RepairRequestDetail = lazy(() => import("../../views/client/repairRequests/RepairRequestDetail"));
const NewRequest = lazy(() => import("../../views/client/serviceRequests/NewRequest"));
const ServiceRequests = lazy(() => import("../../views/client/serviceRequests/ServiceRequests"));
const ServiceRequestDetail = lazy(() => import("../../views/client/serviceRequests/ServiceRequestDetail"));
const EditServiceRequest = lazy(() => import("../../views/client/serviceRequests/EditServiceRequest"));
const ServiceAgreementDetail = lazy(() => import("../../views/client/serviceAgreements/ServiceAgreementDetail"));
const ServiceAgreements = lazy(() => import("../../views/client/serviceAgreements/ServiceAgreements"));
const PartApprovals = lazy(() => import("../../views/client/partApprovals/PartApprovals"));
const PartApprovalDetail = lazy(() => import("../../views/client/partApprovals/PartApprovalDetail"));
const ClientFinance = lazy(() => import("../../views/client/finance/ClientFinance"));
const ClientInvoiceDetail = lazy(() => import("../../views/client/billing/ClientInvoiceDetail"));

const NewBodyOfWater = lazy(() => import("../../views/client/pools/NewBodyOfWater"));
const BodyOfWaterDetailView = lazy(() => import("../../views/client/pools/BodyOfWaterDetailView"));

const ClientProfile = lazy(() => import('../../views/client/account/ClientProfile'));
const ClientSettings = lazy(() => import('../../views/client/account/ClientSettings'));
export const clientRoutes = [
    
    {
        path:'/client/connect-to-company', 
        element: <ConnectToCompany/>,
        ability :['Admin','Client'], 
        role:'Client'
    },
    {
        path:'/client/dashboard', 
        element: <Dashboard/>,
        ability :['Admin','Client'], 
        role:'Client'
    },
    {
        path:'/companies',
        element: <Companies/>,
        ability :['Admin','Client'],
        role:'Client'
    },
    {
        path:'/client/settings',
        element: <ClientSettings/>,
        ability :['Admin','Client'],
        role:'Client'
    },  
    {
        path:'/client/profile',
        element: <ClientProfile/>,
        ability :['Admin','Client'],
        role:'Client'
    },
    {
        path:'/serviceLocation/connect/:linkedInviteId',
        element: <ConnectServiceLocation/>,
        ability :['Admin','Client'],
        role:'Client'
    }
    ,
    {
        path:'/serviceLocation/create',
        element: <CreateServiceLocation/>,
        ability :['Admin','Client'],
        role:'Client'
    },
    {
        path:'/client/equipment',
        element: <EquipmentList/>,
        ability :['Admin','Client'],
        role:'Client'
    },
    {
        path:'/client/equipment/:equipmentId',
        element: <EquipmentDetailView/>,
        ability :['Admin','Client'],
        role:'Client'
    },
    {
        path: '/client/equipment/new',
        element: <NewEquipment />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path:'/client/pools-spas/new', 
        element: <NewBodyOfWater/>,
        ability :['Admin','Client'], 
        role:'Client'
    },
    {
        path:'/client/pools-spas/:bodyOfWaterId', 
        element: <BodyOfWaterDetailView/>,
        ability :['Admin','Client'], 
        role:'Client'
    },
    // Detail Views
    {
        path:'/serviceStop/detail/:serviceStopId',
        element: <ServiceHistoryDetail/>,
        ability :['Admin','Client'],
        role:'Client'
    }
    ,
    {
        path:'/companies/profile/:companyId',
        element: <CompanyProfilePage/>,
        ability :['Admin','Client'],
        role:'Client'
    },
    {
        path:'/messages/newCompany/:companyId',
        element: <NewCompanyChat/>,
        ability :['Admin','Client'],
        role:'Client',
        featureFlagId: 'feature_flag_001',
    },
    {
        path:'/client/chat', 
        element: <Messages/>,
        ability :['Admin','Client'], 
        role:'Client',
        featureFlagId: 'feature_flag_001',
    },
    {
        path:'/client/notifications',
        element: <ClientNotifications/>,
        ability :['Admin','Client'],
        role:'Client',
        featureFlagId: 'feature_flag_011',
    },
    {
        path:'/client/chat/details/:chatId',
        element: <CompanyConversation/>,
        ability :['Admin','Client'],
        role:'Client',
        featureFlagId: 'feature_flag_001',
    },
    {
        path:'/client/companies', 
        element: <Companies/>,
        ability :['Admin','Client'], 
        role:'Client'
    },
    {
        path:'/client/saved-companies', 
        element: <SavedCompanies/>,
        ability :['Admin','Client'], 
        role:'Client'
    },
    {
        path:'/client/my-pool', 
        element: <MyPool/>,
        ability :['Admin','Client'], 
        role:'Client'
    },
    {
        path:'/client/my-pool/new', 
        element: <NewPool/>,
        ability :['Admin','Client'], 
        role:'Client'
    },
    {
        path: '/client/repair-requests',
        element: <RepairRequests />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/repair-requests/new',
        element: <NewRepairRequest />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/repair-requests/:repairRequestId',
        element: <RepairRequestDetail />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/service-requests/new/:companyId',
        element: <NewRequest />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/service-requests',
        element: <ServiceRequests />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/service-requests/:requestId',
        element: <ServiceRequestDetail />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/service-requests/edit/:requestId',
        element: <EditServiceRequest />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/service-agreements',
        element: <ServiceAgreements />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/service-agreements/:agreementId',
        element: <ServiceAgreementDetail />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/part-approvals',
        element: <PartApprovals />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/part-approvals/:approvalId',
        element: <PartApprovalDetail />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/customer/part-approvals/:approvalId',
        element: <PartApprovalDetail />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/finance',
        element: <ClientFinance />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/billing',
        element: <ClientFinance />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    },
    {
        path: '/client/billing/invoices/:invoiceId',
        element: <ClientInvoiceDetail />,
        ability: ['Admin', 'Client'],
        role: 'Client'
    }
]
